module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/goodreads-white-bbfd96a43b56f6754d6c32736536ad7c.svg";